import React from "react";
import { useTranslation } from "react-i18next";
import {
  type ITaxCollectorType,
  type TaxCollectorCategory,
  type TaxCollectorTypeId,
} from "@services/payments/types";
import { TaxCollectorType } from "./TaxCollectorType";
import { TaxCollectorTypeListSkeleton } from "./TaxCollectorTypeListSkeleton";

const filterByCategory =
  (category: TaxCollectorCategory) => (taxCollectorType: ITaxCollectorType) =>
    taxCollectorType.category === category;

interface ITaxCollectorTypeListSectionProps {
  taxCollectorTypes?: ITaxCollectorType[];
  onSelect?: (taxCollectorType: ITaxCollectorType) => void;
  selectedId?: TaxCollectorTypeId;
  category: TaxCollectorCategory;
}

export const TaxCollectorTypeSection: React.FC<
  ITaxCollectorTypeListSectionProps
> = (props) => {
  const { taxCollectorTypes, onSelect, selectedId, category } = props;
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <h5 className="pb-2 pt-6 text-sm">
        {t(`paymentSelectModal.category.${category}`)}
      </h5>
      <div className="flex flex-col flex-wrap gap-4 md:flex-row">
        {taxCollectorTypes ? (
          taxCollectorTypes
            .filter(filterByCategory(category))
            .map((paymentTaxCollectorType) => (
              <TaxCollectorType
                key={paymentTaxCollectorType.taxCollectorTypeId}
                className="basis-[calc(33.333%-(1rem*2/3))]"
                selectedId={selectedId}
                onSelect={onSelect}
                taxCollectorType={paymentTaxCollectorType}
              />
            ))
        ) : (
          <TaxCollectorTypeListSkeleton count={5} />
        )}
      </div>
    </React.Fragment>
  );
};
